import { strictEqual } from "./strictEqual.js";
function shallowEqualArray(a, b, arrayElementComparator = strictEqual) {
    if (a.length !== b.length) {
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if (!arrayElementComparator(a[i], b[i])) {
            return false;
        }
    }
    return true;
}
/**
 * Compares two objects (or arrays) for shallow equality.
 *
 * @public
 */
export function shallowEqual(a, b, propertyValueComparator = strictEqual) {
    if (a === b) {
        return true;
    }
    if (a === undefined || b === undefined) {
        return false;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        return shallowEqualArray(a, b);
    }
    if (Array.isArray(a) || Array.isArray(b)) {
        return false;
    }
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) {
        return false;
    }
    const keys = [...new Set([...keysA, ...keysB])];
    for (const key of keys) {
        if (!propertyValueComparator(a[key], b[key])) {
            return false;
        }
    }
    return true;
}
